import { render, staticRenderFns } from "./WishlistSelect.vue?vue&type=template&id=3c42d47a&scoped=true&"
import script from "./WishlistSelect.vue?vue&type=script&lang=js&"
export * from "./WishlistSelect.vue?vue&type=script&lang=js&"
import style0 from "./WishlistSelect.vue?vue&type=style&index=0&id=3c42d47a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42d47a",
  null
  
)

export default component.exports